import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "normalFields", "cloneFields", "modelableInput"]
  static values = {
    sdModelId: String,
    defaultNegativePrompt: { type: String, default: "" }
  }

  connect() {
    // The form's HTML already has the correct initial state
    // Just mark that this is the initial load so we don't clear the model selection
    this.isInitialLoad = true
    this.updateVisibility()
  }

  updateType(event) {
    const button = event.currentTarget
    const type = button.dataset.generationTypeTypeValue

    // Update button styles
    this.buttonTargets.forEach(btn => {
      btn.classList.remove("selected")
    })
    button.classList.add("selected")

    // Update fields visibility
    this.updateVisibility(type)

    // Update form state
    const submitButton = this.element.querySelector('button[type="submit"]')
    if (type === "clone" && !this.hasModelableInputTarget) {
      submitButton.disabled = true
      submitButton.classList.add("opacity-50", "cursor-not-allowed")
    } else {
      submitButton.disabled = false
      submitButton.classList.remove("opacity-50", "cursor-not-allowed")
    }
  }

  updateVisibility(type = null) {
    // If type is not provided, get it from the selected button
    if (!type) {
      const selectedButton = this.buttonTargets.find(btn => btn.classList.contains("selected"))
      type = selectedButton?.dataset.generationTypeTypeValue
    }

    // Update fields visibility
    if (type === "normal") {
      this.normalFieldsTarget.classList.remove("hidden")
      this.cloneFieldsTarget.classList.add("hidden")
      // Set to Stable Diffusion base model
      if (this.hasModelableInputTarget) {
        this.modelableInputTarget.value = this.sdModelIdValue
      }
      // Restore default negative prompt if it was cleared
      const negativePromptInput = document.querySelector("textarea[name='image_generation_task[negative_prompt]']")
      if (negativePromptInput && !negativePromptInput.value) {
        negativePromptInput.value = this.defaultNegativePromptValue
      }
    } else {
      this.normalFieldsTarget.classList.add("hidden")
      this.cloneFieldsTarget.classList.remove("hidden")
      // Don't clear the model selection when switching to clone type if it's the initial load
      if (this.hasModelableInputTarget && !this.isInitialLoad) {
        this.modelableInputTarget.value = ""
      }
    }
    
    // After first load, mark that subsequent changes are user-initiated
    this.isInitialLoad = false
  }
} 